@if (isIntroShown) {
  <app-slide-separator
    [type]="data?.type"
    [title]="data?.title"
    [introText]="data?.video_pre_text"
    [buttonText]="'INTRO_SLIDE.BUTTON.VIDEO' | translate"
    (buttonClicked)="handleContinueClick()"
    [skipLink]="nextLink"
    [backLink]="backLink"
    [specialSlide]="data?.special_slide_type">
  </app-slide-separator>
}
@if (data && !isIntroShown) {
  <app-video [video]="data?.video" [autoplay]="true" [timestamp]="timestamp"> </app-video>
}
